import { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2">
              <span className={`text-2xl font-bold transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}>
                ayuda<span className="text-teal-500">domiciliogc</span>.es
              </span>
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('servicios')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('beneficios')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Beneficios
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('testimonios')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Testimonios
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Solicitar presupuesto
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('servicios')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('beneficios')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer"
            >
              Beneficios
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer"
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('testimonios')}
              className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer"
            >
              Testimonios
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="block w-full bg-teal-500 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-600 transition-colors cursor-pointer"
            >
              Solicitar presupuesto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;